// 表单数据
export const formData = {
    name: '',
    number: '',
    short_name: '',
    property: '',
    duty_people: '',
    phone_num: '',
    exten_num: '',
    remark: ''
}

// 表单验证规则
export const formRules = {
    name: [{ required: true, message: "部门名称不能为空", trigger: "blur" }],
    number: [{ required: true, message: "部门编号能为空", trigger: "blur" }],
    short_name: [{ required: true, message: "部门简称不能为空", trigger: "blur" }],
    property: [{ required: true, message: "部门性质不能为空", trigger: "blur" }],
    duty_people: [{ required: true, message: " 负责人不能为空", trigger: "blur" }],
    phone_num: [{ required: true, message: "电话号码不能为空", trigger: "blur" }],
    exten_num: [{ required: true, message: "分机号不能为空", trigger: "blur" }],
    remark: [{ required: true, message: "备注不能为空", trigger: "blur" }]
}